import { render, staticRenderFns } from "./WorkshopParticipantsAttendanceGridCpt.vue?vue&type=template&id=4f489695&scoped=true&"
import script from "./WorkshopParticipantsAttendanceGridCpt.vue?vue&type=script&lang=ts&"
export * from "./WorkshopParticipantsAttendanceGridCpt.vue?vue&type=script&lang=ts&"
import style0 from "./WorkshopParticipantsAttendanceGridCpt.vue?vue&type=style&index=0&id=4f489695&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f489695",
  null
  
)

export default component.exports